import React from "react";
import classnames from "classnames";

import "./layout.scss";

export function TypeArea({children, className}) {
  const combinedClassName = classnames("type-area", className);

  return (
    <div className={combinedClassName}>{children}</div>
  );
}
